import { render, staticRenderFns } from "./updatePhone.vue?vue&type=template&id=10319026&scoped=true&"
import script from "./updatePhone.vue?vue&type=script&lang=js&"
export * from "./updatePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10319026",
  null
  
)

export default component.exports